// auth.guard.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '@app/areas/auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  private resultTree(ok: boolean, url: string): boolean | UrlTree {
    return ok ? true : this.router.createUrlTree(
      ['/account/login'],
      { queryParams: { returnUrl: url, reason: 'session_expired' } }
    );
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.auth.checkLoggedIn().pipe(
      take(1),
      map(ok => this.resultTree(ok, state.url))
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
